// import packages
import React, {useState} from "react";
import {connect} from "react-redux";
import {Link} from 'react-router-dom'

// Import assets
import "./about.scss"
import {CheckedIcon, SliderArrowIcon} from "../../../assets/images";

// Import utils
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";
import VisibilitySensor from "react-visibility-sensor";
import {CountUp} from "use-count-up";
import {ImagesSlider} from "../../../components/ui-elements/imagesZoomSlider/ImagesSlider";
import LinkBtn from "../../../components/buttons/LinkBtn";
import {ImageModal} from "../../../components/ui-elements/image-modal/ImageModal";


export function About(props) {
    const {about, staticTexts, aboutSlider} = props
    const [imagesSliderOpen, setImagesSliderOpen] = useState(false)
    const [modalCurrentImageIndex, setModalCurrentImageIndex] = useState(0)
    const [modalImagePathList, setModalImagePathList] = useState([])

    const openImagesSlider = (modalImagePathList, imageIndex) => {
        setImagesSliderOpen(true)
        setModalCurrentImageIndex(imageIndex);
        setModalImagePathList(modalImagePathList);
    }

    const closeImagesSlider = () => {
        setImagesSliderOpen(false)
        setTimeout(() => {
            setModalImagePathList([])
            setModalCurrentImageIndex(0)
        }, 150)
    }

    return <div className={'HomepageAbout'}>
        <div className={'HomepageAboutContent'}>
            <div className="FeaturesWrapper">
                <h2 className={'features-title'}>{about.title || '7 лет на рынке недвижимости'}</h2>
                <div className={'features-text'}
                     dangerouslySetInnerHTML={{__html: about.description || 'Многолетний опыт, финансовая устойчивость, надежность, соблюдение сроков, социальная ответственность.'}}/>
                <LinkBtn link={'/about'} staticTexts={staticTexts}/>
                <div className={'features-bottom-content'}>
                    <div className={'features-title'}>
                        {staticTexts?.features_title}
                    </div>
                    <div className={'features'}>
                        {about?.features && about?.features?.length && about.features.map(item => {
                            return <Link to={getUrlWithLocal('/about')} key={item.slug}
                                         className={'features-item'}>
                                <CheckedIcon/>
                                <div className={'features-text'}>
                                    <span className={'features-title'}>{item?.title}</span>
                                    <span className={'features-info'}>{item?.description}</span>
                                </div>
                            </Link>
                        })}
                    </div>
                </div>
            </div>
            <div className={'About-img-wrapper'}>
                <div className={'first-img-block'} onClick={() => openImagesSlider(aboutSlider, 0)}>
                    <img src={generateFileMediaUrl(aboutSlider[0]?.mediaMain?.path)} alt=""/>
                </div>
                <div className={'oder-img-block'}>
                    {
                        aboutSlider?.slice(1, 4)?.map((item, index) => {
                            return <div className={'img-block'}
                                        onClick={() => openImagesSlider(aboutSlider, index + 1)}>
                                <img src={generateFileMediaUrl(item?.mediaMain?.path)} alt=""/>
                            </div>
                        })
                    }
                    {
                        aboutSlider?.length > 4 ? <span className={'more-img'}>
                                        + {aboutSlider?.length - 4}
                                    </span> : ''
                    }
                </div>
            </div>
        </div>
        <div className={'About-bottom-block'}>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className={`counts_item_count `}>
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.credit_count)}
                                         duration={1} delay={4} easing="linear"/>
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.credit_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.credit_description}
                </div>
            </div>
            <span className={'line'}/>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className="counts_item_count">
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.family_count)}
                                         duration={1} delay={4} easing="linear"/>
                                +
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.family_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.family_description}
                </div>
            </div>
            <span className={'line'}/>
            <div className={'About-bottom-info'}>
                <div className={'info-top'}>
                    <VisibilitySensor>{({isVisible}) => {
                        return (
                            <div className="counts_item_count">
                                <CountUp isCounting={isVisible} start={0}
                                         end={Number(staticTexts?.square_count)}
                                         duration={1} delay={4} easing="linear"/>
                            </div>
                        );
                    }}</VisibilitySensor>
                    <p>{staticTexts?.square_text}</p>
                </div>
                <div className={'info-bottom'}>
                    {staticTexts?.square_description}
                </div>
            </div>
        </div>
        {/*    {imagesSliderOpen && <ImagesSlider visible={imagesSliderOpen}
                                           isAbout={true}
                                           modalImagePathList={modalImagePathList}
                                           modalCurrentImageIndex={modalCurrentImageIndex}
                                           closeModal={closeImagesSlider}/>}*/}
        {imagesSliderOpen && <ImageModal visible={imagesSliderOpen}
                                         isAbout={true}
                                         modalImagePathList={aboutSlider.map(item => item?.mediaMain?.path)}
                                         modalCurrentImageIndex={modalCurrentImageIndex}
                                         closeModal={closeImagesSlider}/>}
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'aboutSlider',
    'about'
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(About);
